angular.module('app.filters').filter('scoreboardTeamName', () => {
  'ngInject';
  return (label, dflt = '') => {
    // See origin_task/scorelayout#sanitizeName
    label = label || dflt;
    label = label.toUpperCase();
    if (label.length > 4) {
      label = label.substring(0, 4);
    }
    label = label.replace(/[^\x20-\x7E]+/g, '-');
    while (label.length < 4) {
      label += ' ';
    }
    return label;
  };
});



// WEBPACK FOOTER //
// ./app/filters/scoreboard-team-name.js